import { nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'

export default {
  data () {
    return {
      fetching: {
        stocks: false
      },
      options: {
        stocks: []
      }
    }
  },

  methods: {

    async getStocks (context, warehouseCode, productCodes) {
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const fetching = context.fetching?.stocks
      const options = context.options?.stocks

      const hasInvalidContext = [
        fetching,
        options
      ].some(nullOrUndefined)

      if (hasInvalidContext) {
        throw Error('Invalid context object')
      }

      context.fetching.stocks = true

      const filters = {
        warehouse_code: warehouseCode,
        product_codes: productCodes
      }

      return await SSharedList.getStocks(filters).then(
        ({ data }) => {
          context.options.stocks = data
        }
      ).catch(() => {
        context.options.stocks = []
      }).finally(() => {
        context.fetching.stocks = false
      })
    }
  }
}
